(()=>{
 const template=document.getElementById('lc-catalog-menu-template');
 const configNode=document.getElementById('lc-catalog-menu-config');
 if(!template||!configNode)return;
 const config=JSON.parse(configNode.textContent);
 const base=window.LC_ASSET_BASE||'';
 const esc=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
 const spark='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5Z"/></svg>';
 function refresh(){
  const mega=document.getElementById('mega');
  if(mega){
   mega.classList.add('lc-catalog-menu');
   const columns=mega.querySelector('.shop-columns');
   if(columns&&!columns.querySelector('.lc-nav-column')){
    columns.replaceChildren(template.content.cloneNode(true));
   }
   if(columns&&!mega.querySelector('.lc-nav-overview')){
    const overview=document.createElement('div');overview.className='lc-nav-overview';
    overview.innerHTML='<span>A considered collection. Your kind of comfort.</span><a href="'+esc(config.allUrl)+'">Shop the complete collection →</a>';
    columns.before(overview);
   }
  }
  document.querySelectorAll('#mobile-navigation .mobile-photo-grid,#p-mobile .mobile-photo-grid,#pr-mobile .mobile-photo-grid,.mobile-shop-categories').forEach(grid=>{
   if(grid.classList.contains('lc-mobile-catalog'))return;
   grid.classList.add('lc-mobile-catalog');
   grid.innerHTML=config.parents.map(p=>'<details><summary><img src="'+esc(base+p.image)+'" width="64" height="52" alt="" loading="lazy"><span>'+esc(p.title)+'</span><span aria-hidden="true">+</span></summary><div class="lc-mobile-links">'+p.children.map(c=>'<a href="'+esc(c.url)+'">'+esc(c.title)+'</a>').join('')+'<a href="'+esc(p.url)+'"><strong>Shop all '+esc(p.title.toLowerCase())+' →</strong></a><details class="lc-nav-featured"><summary>Featured <span>+</span></summary><div>'+p.featured.map(f=>'<a class="lc-nav-feature" href="/products/'+esc(f[0])+'"><span>'+esc(f[1])+'</span><small class="shop-tag" data-badge="'+esc(f[2])+'">'+spark+esc(f[2])+'</small></a>').join('')+'</div></details></div></details>').join('')+'<a class="lc-mobile-all" href="'+esc(config.allUrl)+'">Shop the complete collection →</a>';
  });
 }
 const observer=new MutationObserver(refresh);
 observer.observe(document.body,{subtree:true,childList:true});
 refresh();
 document.addEventListener('shopify:section:load',refresh);
})();
